import React from "react";

export const BulletPointIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66797 10.625C3.90714 10.625 3.29297 11.2392 3.29297 12C3.29297 12.7608 3.90714 13.375 4.66797 13.375C5.4288 13.375 6.04297 12.7608 6.04297 12C6.04297 11.2392 5.4288 10.625 4.66797 10.625ZM4.66797 5.125C3.90714 5.125 3.29297 5.73917 3.29297 6.5C3.29297 7.26083 3.90714 7.875 4.66797 7.875C5.4288 7.875 6.04297 7.26083 6.04297 6.5C6.04297 5.73917 5.4288 5.125 4.66797 5.125ZM4.66797 16.125C3.90714 16.125 3.29297 16.7483 3.29297 17.5C3.29297 18.2517 3.9163 18.875 4.66797 18.875C5.41964 18.875 6.04297 18.2517 6.04297 17.5C6.04297 16.7483 5.4288 16.125 4.66797 16.125ZM7.41797 18.4167H20.2513V16.5833H7.41797V18.4167ZM7.41797 12.9167H20.2513V11.0833H7.41797V12.9167ZM7.41797 5.58333V7.41667H20.2513V5.58333H7.41797Z"
        fill="black"
        fill-opacity="0.54"
      />
    </svg>
  );
};
